import React, { useEffect } from 'react'
import Div from '../Div'
import Spacing from '../Spacing'
import PageHeading from '../PageHeading'

export default function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <PageHeading 
        title='Privacy Policy'
        bgSrc='/images/about_hero_bg.jpeg'
        pageLinkText='Privacy Policy'
      />
      <Spacing lg='90' md='45'/>
      <Div className="container">
        <ul>
          <li>
            <p><strong>Effective Date:</strong> 1 Jan 2024</p>
          </li>
          <li>
            <p>
              At RLAB Group ("we", "us", or "our"), we are committed to protecting
              and respecting your privacy. This Privacy Policy explains how we
              collect, use, disclose, and safeguard your personal information when
              you visit our website www.rlabgroup.ca (the "Site") and interact
              with our services, including when you submit information through our
              contact forms.
            </p>
            <p>
              Please read this Privacy Policy carefully to understand how we
              handle your personal data.
            </p>
          </li>
          <li>
            <p><strong>1. Information We Collect</strong></p>
          </li>
          <li>
            <p>
              We collect two types of information from visitors to our Site: 
              personal information and non-personal information.
            </p>
          </li>
          <li>
            <p><strong>Personal Information:</strong> This includes any data that identifies you personally. We collect personal information when you voluntarily provide it to us through contact forms or other interactive features on our Site. This may include:</p>
            <ul>
              <li><p>Name</p></li>
              <li><p>Email address</p></li>
              <li><p>Phone number</p></li>
              <li><p>Company name (if applicable)</p></li>
              <li><p>Any other information you provide in the course of interacting with our forms</p></li>
            </ul>
          </li>
          <li>
            <p><strong>Non-Personal Information:</strong> This includes data that cannot be used to identify you. This may include your browser type, IP address, device type, pages visited, and other technical data collected through cookies and analytics tools.</p>
          </li>
          <li>
            <p><strong>2. How We Use Your Information</strong></p>
          </li>
          <li>
            <p>We use the information we collect for the following purposes:</p>
            <ul>
              <li><p>To respond to your inquiries or requests made via contact forms or other communications</p></li>
              <li><p>To provide you with updates, newsletters, and marketing communications (with your consent)</p></li>
              <li><p>To improve our Site and services by analyzing user interactions</p></li>
              <li><p>To meet legal obligations and resolve any disputes</p></li>
            </ul>
          </li>
          <li>
            <p><strong>3. How We Protect Your Information</strong></p>
          </li>
          <li>
            <p>
              We take the protection of your personal information seriously. We
              implement appropriate physical, technical, and administrative
              safeguards to protect your personal data from unauthorized access,
              loss, misuse, or disclosure. However, no data transmission over the
              internet can be guaranteed to be 100% secure. While we strive to
              protect your personal data, we cannot guarantee its absolute security.
            </p>
          </li>
          <li>
            <p><strong>4. Cookies and Tracking Technologies</strong></p>
          </li>
          <li>
            <p>
              We may use cookies and similar technologies to collect non-personal
              information about your use of our Site. Cookies are small data files
              stored on your device that help us track usage patterns and improve
              user experience. You can manage your cookie preferences through your
              browser settings, including disabling cookies altogether. However,
              please note that certain features of our Site may not function
              properly if you disable cookies.
            </p>
          </li>
          <li>
            <p><strong>5. Third-Party Disclosure</strong></p>
          </li>
          <li>
            <p>
              We do not sell, trade, or rent your personal information to third
              parties. However, we may share your information in the following
              circumstances:
            </p>
            <ul>
              <li><p>With trusted third-party service providers who assist us in operating our Site or conducting our business (e.g., email marketing services, analytics tools). These third parties are obligated to keep your information confidential.</p></li>
              <li><p>If required by law, in response to legal processes, or to protect our rights and safety, or the rights and safety of others.</p></li>
            </ul>
          </li>
          <li>
            <p><strong>6. Your Rights and Choices</strong></p>
          </li>
          <li>
            <p>
              As a resident of Canada, you have certain rights regarding your
              personal data, including:
            </p>
            <ul>
              <li><p><strong>Access:</strong> You can request access to the personal information we hold about you.</p></li>
              <li><p><strong>Correction:</strong> You can request that we correct any inaccuracies in your personal information.</p></li>
              <li><p><strong>Deletion:</strong> You can request that we delete your personal information, subject to certain legal exceptions.</p></li>
              <li><p><strong>Opt-Out:</strong> You can withdraw your consent to receive marketing communications at any time by following the unsubscribe instructions in our emails or by contacting us directly.</p></li>
            </ul>
          </li>
          <li>
            <p>To exercise any of these rights, please contact us at <a href="mailto:info@rlabgroup.ca">info@rlabgroup.ca</a>.</p>
          </li>
          <li>
            <p><strong>7. Retention of Your Information</strong></p>
          </li>
          <li>
            <p>
              We retain your personal information for as long as necessary to
              fulfill the purposes outlined in this Privacy Policy, or as required
              by law. Once your information is no longer needed, we will securely
              delete or anonymize it.
            </p>
          </li>
          <li>
            <p><strong>8. Changes to This Privacy Policy</strong></p>
          </li>
          <li>
            <p>
              We may update this Privacy Policy from time to time to reflect changes
              in our practices, technologies, or legal requirements. When we make
              updates, we will revise the "Effective Date" at the top of this page.
              We encourage you to review this Privacy Policy periodically to stay
              informed about how we are protecting your information.
            </p>
          </li>
          <li>
            <p><strong>9. Contact Us</strong></p>
          </li>
          <li>
            <p>
              If you have any questions, concerns, or requests regarding this
              Privacy Policy or the handling of your personal information, please
              contact us at:
            </p>
            <p>
              <strong>RLAB Group</strong><br />
              <a href="mailto:info@rlabgroup.ca">info@rlabgroup.ca</a>
            </p>
          </li>
        </ul>
      </Div>
    </>
  )
}
